export interface Manga {
  id: number;
  title: string;
  author: string;
  category: string;
  cover: string;
  views: string;
  rating: number;
  status: '连载中' | '已完结';
  latest: string;
  desc: string;
  tags: string[];
}

export interface MangaCategory {
  name: string;
  count: string;
}

export const categories: MangaCategory[] = [
  { name: '热血', count: '2.3万部' },
  { name: '恋爱', count: '1.9万部' },
  { name: '玄幻', count: '1.6万部' },
  { name: '悬疑', count: '1.1万部' },
  { name: '搞笑', count: '1.4万部' },
  { name: '科幻', count: '0.9万部' },
  { name: '校园', count: '1.2万部' },
  { name: '冒险', count: '1.0万部' },
  { name: '奇幻', count: '0.8万部' },
  { name: '都市', count: '1.5万部' },
];

export const popularManga: Manga[] = [
  {
    id: 1,
    title: '星海奇缘',
    author: '墨小尘',
    category: '恋爱',
    cover: 'https://readdy.ai/api/search-image?query=Romantic%20anime%20manga%20cover%20illustration%20of%20a%20young%20couple%20gazing%20at%20a%20sparkling%20starry%20night%20sky%20with%20flowing%20galaxy%20nebula%2C%20warm%20golden%20and%20soft%20rose%20tones%2C%20dreamy%20glowing%20stars%2C%20clean%20comic%20composition%2C%20vibrant%20youthful%20style%2C%20polished%20digital%20painting&width=600&height=800&seq=cover-star-sea&orientation=portrait',
    views: '1286万',
    rating: 9.6,
    status: '连载中',
    latest: '第 168 话',
    desc: '落魄画师与星轨少女跨越银河的宿命之恋。',
    tags: ['甜宠', '星际', '治愈'],
  },
  {
    id: 2,
    title: '热血武道传',
    author: '铁拳小武',
    category: '热血',
    cover: 'https://readdy.ai/api/search-image?query=Energetic%20anime%20manga%20cover%20of%20a%20muscular%20young%20fighter%20striking%20a%20dynamic%20punch%20pose%20with%20fire%20and%20energy%20aura%20behind%20him%2C%20bright%20orange%20and%20red%20explosive%20effects%2C%20high%20contrast%20battle%20action%20composition%2C%20bold%20clean%20inlines%2C%20vibrant%20shonen%20manga%20style%20digital%20painting&width=600&height=800&seq=cover-heat&orientation=portrait',
    views: '2031万',
    rating: 9.8,
    status: '连载中',
    latest: '第 320 话',
    desc: '平凡少年觉醒上古武脉，踏上强者巅峰之路。',
    tags: ['格斗', '修炼', '逆袭'],
  },
  {
    id: 3,
    title: '萌系小厨娘',
    author: '阿圆团团',
    category: '校园',
    cover: 'https://readdy.ai/api/search-image?query=Cute%20anime%20manga%20cover%20of%20a%20cheerful%20young%20girl%20chef%20wearing%20apron%20holding%20a%20bowl%20of%20steaming%20ramen%2C%20warm%20pastel%20pink%20and%20cream%20kitchen%20background%2C%20adorable%20sparkling%20eyes%2C%20soft%20glowing%20bokeh%2C%20sweet%20wholesome%20moe%20comic%20style%20digital%20illustration&width=600&height=800&seq=cover-chef&orientation=portrait',
    views: '986万',
    rating: 9.4,
    status: '连载中',
    latest: '第 142 话',
    desc: '小小厨娘用美食温暖校园里的每一个少年。',
    tags: ['日常', '美食', '治愈'],
  },
  {
    id: 4,
    title: '末世求生指南',
    author: '荒原老狼',
    category: '科幻',
    cover: 'https://readdy.ai/api/search-image?query=Dark%20anime%20manga%20cover%20of%20a%20survivor%20silhouette%20standing%20in%20a%20ruined%20post%20apocalyptic%20city%20with%20embers%20and%20fog%2C%20moody%20teal%20and%20deep%20amber%20lighting%2C%20cinematic%20survival%20atmosphere%2C%20gritty%20detailed%20comic%20illustration%20with%20dramatic%20contrast&width=600&height=800&seq=cover-apocalypse&orientation=portrait',
    views: '1547万',
    rating: 9.2,
    status: '已完结',
    latest: '第 96 话',
    desc: '末日降临，少年与伙伴在废墟中寻找希望与真相。',
    tags: ['生存', '科幻', '冒险'],
  },
  {
    id: 5,
    title: '剑与魔法之旅',
    author: '晨曦旅人',
    category: '奇幻',
    cover: 'https://readdy.ai/api/search-image?query=Epic%20fantasy%20anime%20manga%20cover%20of%20a%20sword%20wielding%20hero%20and%20a%20sorceress%20casting%20glowing%20magic%20in%20front%20of%20an%20ancient%20floating%20castle%2C%20emerald%20and%20gold%20mystical%20aurora%2C%20grand%20adventure%20composition%2C%20rich%20detailed%20fantasy%20comic%20artwork%20digital%20painting&width=600&height=800&seq=cover-sword&orientation=portrait',
    views: '1780万',
    rating: 9.5,
    status: '连载中',
    latest: '第 254 话',
    desc: '少年剑客与魔法少女结伴，闯荡奇幻大陆。',
    tags: ['冒险', '魔法', '伙伴'],
  },
  {
    id: 6,
    title: '推理侦探社',
    author: '墨镜老K',
    category: '悬疑',
    cover: 'https://readdy.ai/api/search-image?query=Mysterious%20anime%20manga%20cover%20of%20a%20young%20detective%20with%20a%20magnifying%20glass%20and%20trench%20coat%20surrounded%20by%20floating%20clue%20symbols%20and%20question%20marks%2C%20noir%20moody%20navy%20and%20amber%20lighting%2C%20intriguing%20criminal%20mystery%20atmosphere%2C%20sharp%20comic%20composition%20digital%20illustration&width=600&height=800&seq=cover-detective&orientation=portrait',
    views: '867万',
    rating: 9.3,
    status: '连载中',
    latest: '第 210 话',
    desc: '校园侦探社少年们解开一个个离奇悬案。',
    tags: ['推理', '悬疑', '校园'],
  },
  {
    id: 7,
    title: '仙侠青云路',
    author: '云中客',
    category: '玄幻',
    cover: 'https://readdy.ai/api/search-image?query=Ethereal%20xianxia%20anime%20manga%20cover%20of%20a%20cultivator%20soaring%20on%20a%20flying%20sword%20through%20misty%20mountain%20clouds%20with%20ancient%20pagoda%20silhouettes%2C%20jade%20green%20and%20white%20moonlight%20palette%2C%20flowing%20robes%20and%20ribbons%2C%20breathtaking%20wuxia%20fantasy%20comic%20artwork%20digital%20painting&width=600&height=800&seq=cover-xianxia&orientation=portrait',
    views: '1425万',
    rating: 9.7,
    status: '连载中',
    latest: '第 189 话',
    desc: '一介凡人偶得仙缘，踏上荡气回肠的修仙之路。',
    tags: ['修仙', '成长', '仙侠'],
  },
  {
    id: 8,
    title: '搞笑日常漫',
    author: '皮皮虾',
    category: '搞笑',
    cover: 'https://readdy.ai/api/search-image?query=Hilarious%20anime%20manga%20cover%20of%20a%20group%20of%20comically%20overreacting%20school%20students%20with%20exaggerated%20faces%20and%20speed%20lines%2C%20bright%20yellow%20and%20orange%20pop%20colors%2C%20goofy%20energetic%20comedy%20composition%2C%20bold%20outlines%2C%20vibrant%20lighthearted%20gag%20manga%20style%20digital%20illustration&width=600&height=800&seq=cover-funny&orientation=portrait',
    views: '1123万',
    rating: 9.1,
    status: '连载中',
    latest: '第 302 话',
    desc: '四个沙雕好友的爆笑校园日常，笑到停不下来。',
    tags: ['沙雕', '校园', '爆笑'],
  },
  {
    id: 9,
    title: '都市异能王者',
    author: '深夜码农',
    category: '都市',
    cover: 'https://readdy.ai/api/search-image?query=Cool%20anime%20manga%20cover%20of%20a%20confident%20young%20man%20in%20a%20suit%20with%20glowing%20blue%20crystal%20power%20around%20his%20hand%20against%20a%20neon%20night%20city%20skyline%2C%20dynamic%20cyber%20urban%20background%2C%20rich%20purple%20and%20gold%20highlights%2C%20stylish%20modern%20action%20comic%20artwork%20digital%20painting&width=600&height=800&seq=cover-city&orientation=portrait',
    views: '1650万',
    rating: 9.0,
    status: '连载中',
    latest: '第 226 话',
    desc: '身负异能的普通上班族，暗中守护这座繁华都市。',
    tags: ['异能', '都市', '热血'],
  },
  {
    id: 10,
    title: '机甲战争纪元',
    author: '齿轮社',
    category: '科幻',
    cover: 'https://readdy.ai/api/search-image?query=Majestic%20anime%20manga%20cover%20of%20a%20giant%20mecha%20robot%20rising%20against%20a%20fiery%20battlefield%20sky%20with%20explosions%20and%20debris%2C%20titanium%20gray%20and%20embers%20orange%2C%20epic%20scale%20war%20composition%2C%20high%20detail%20mecha%20anime%20artwork%20digital%20painting&width=600&height=800&seq=cover-mecha&orientation=portrait',
    views: '1378万',
    rating: 9.4,
    status: '已完结',
    latest: '第 210 话',
    desc: '人类最后的希望，寄托在一台少年驾驶的机甲上。',
    tags: ['机甲', '战争', '热血'],
  },
  {
    id: 11,
    title: '甜心校园日常',
    author: '奶糖小姐',
    category: '恋爱',
    cover: 'https://readdy.ai/api/search-image?query=Heartwarming%20anime%20manga%20cover%20of%20a%20blushing%20schoolgirl%20and%20a%20shy%20boy%20sitting%20on%20a%20school%20rooftop%20at%20sunset%2C%20cherry%20blossoms%20floating%20in%20the%20air%2C%20soft%20pink%20and%20peach%20warm%20tones%2C%20sweet%20romantic%20youth%20comic%20style%20digital%20illustration&width=600&height=800&seq=cover-school&orientation=portrait',
    views: '921万',
    rating: 9.2,
    status: '连载中',
    latest: '第 118 话',
    desc: '一场青涩又甜蜜的校园恋爱，悄悄发芽。',
    tags: ['纯爱', '校园', '青春'],
  },
  {
    id: 12,
    title: '恐怖异闻录',
    author: '夜行者',
    category: '悬疑',
    cover: 'https://readdy.ai/api/search-image?query=Spooky%20anime%20manga%20cover%20of%20a%20mysterious%20hooded%20figure%20holding%20a%20lantern%20in%20a%20foggy%20abandoned%20mansion%20at%20midnight%2C%20deep%20crimson%20and%20shadow%20blue%20moody%20lighting%2C%20creepy%20atmospheric%20horror%20composition%2C%20dark%20detailed%20comic%20artwork%20digital%20painting&width=600&height=800&seq=cover-horror&orientation=portrait',
    views: '749万',
    rating: 9.0,
    status: '连载中',
    latest: '第 84 话',
    desc: '小镇接连出现离奇事件，真相隐藏在黑暗之中。',
    tags: ['惊悚', '灵异', '悬念'],
  },
];

export const latestManga: Manga[] = [
  { ...popularManga[3], id: 101 },
  { ...popularManga[7], id: 102 },
  { ...popularManga[1], id: 103 },
  { ...popularManga[9], id: 104 },
  { ...popularManga[5], id: 105 },
  { ...popularManga[11], id: 106 },
  { ...popularManga[2], id: 107 },
  { ...popularManga[0], id: 108 },
];

export interface RankingItem {
  rank: number;
  title: string;
  author: string;
  cover: string;
  views: string;
}

export const rankingList: RankingItem[] = [
  { rank: 1, title: '热血武道传', author: '铁拳小武', cover: 'https://readdy.ai/api/search-image?query=Anime%20manga%20cover%20of%20a%20young%20fighter%20in%20a%20dynamic%20battle%20pose%20with%20fire%20energy%20aura%2C%20bold%20orange%20red%20explosive%20background%2C%20vibrant%20shonen%20action%20style%2C%20clean%20comic%20illustration&width=300&height=400&seq=rank-1&orientation=portrait', views: '2031万' },
  { rank: 2, title: '星海奇缘', author: '墨小尘', cover: 'https://readdy.ai/api/search-image?query=Romantic%20anime%20manga%20cover%20of%20a%20couple%20under%20a%20starry%20galaxy%20sky%20with%20glowing%20stars%2C%20warm%20gold%20and%20rose%20tones%2C%20dreamy%20romance%20comic%20style%20digital%20illustration&width=300&height=400&seq=rank-2&orientation=portrait', views: '1286万' },
  { rank: 3, title: '剑与魔法之旅', author: '晨曦旅人', cover: 'https://readdy.ai/api/search-image?query=Epic%20fantasy%20anime%20cover%20of%20a%20hero%20and%20sorceress%20with%20magic%20glow%20before%20a%20floating%20castle%2C%20emerald%20and%20gold%20aurora%2C%20grand%20adventure%20comic%20artwork%20digital%20painting&width=300&height=400&seq=rank-3&orientation=portrait', views: '1780万' },
  { rank: 4, title: '都市异能王者', author: '深夜码农', cover: 'https://readdy.ai/api/search-image?query=Cool%20anime%20cover%20of%20a%20young%20man%20with%20glowing%20power%20in%20hand%20against%20neon%20city%20skyline%2C%20cyber%20urban%20night%20background%2C%20stylish%20modern%20action%20comic%20digital%20painting&width=300&height=400&seq=rank-4&orientation=portrait', views: '1650万' },
  { rank: 5, title: '末世求生指南', author: '荒原老狼', cover: 'https://readdy.ai/api/search-image?query=Dark%20anime%20cover%20of%20a%20survivor%20silhouette%20in%20a%20ruined%20city%20with%20embers%20and%20fog%2C%20moody%20teal%20amber%20lighting%2C%20cinematic%20survival%20comic%20illustration&width=300&height=400&seq=rank-5&orientation=portrait', views: '1547万' },
  { rank: 6, title: '仙侠青云路', author: '云中客', cover: 'https://readdy.ai/api/search-image?query=Ethereal%20anime%20cover%20of%20a%20cultivator%20on%20flying%20sword%20through%20misty%20mountains%20with%20pagoda%2C%20jade%20green%20white%20moonlight%2C%20wuxia%20fantasy%20comic%20digital%20painting&width=300&height=400&seq=rank-6&orientation=portrait', views: '1425万' },
  { rank: 7, title: '搞笑日常漫', author: '皮皮虾', cover: 'https://readdy.ai/api/search-image?query=Hilarious%20anime%20cover%20of%20a%20group%20of%20goofy%20school%20students%20with%20exaggerated%20comic%20faces%2C%20bright%20yellow%20orange%20pop%20colors%2C%20energetic%20gag%20manga%20style%20digital%20illustration&width=300&height=400&seq=rank-7&orientation=portrait', views: '1123万' },
  { rank: 8, title: '机甲战争纪元', author: '齿轮社', cover: 'https://readdy.ai/api/search-image?query=Majestic%20anime%20cover%20of%20a%20giant%20mecha%20robot%20in%20a%20fiery%20battlefield%20with%20explosions%2C%20titanium%20gray%20and%20embers%20orange%2C%20epic%20mecha%20war%20comic%20artwork%20digital%20painting&width=300&height=400&seq=rank-8&orientation=portrait', views: '1378万' },
];